import { render, staticRenderFns } from "./sider-menu-item.vue?vue&type=template&id=1cba4987&"
import script from "./sider-menu-item.vue?vue&type=script&lang=js&"
export * from "./sider-menu-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports